var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainIconNotifySuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base/Bas-028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 8.50403V7.88403C13.3334 7.51584 13.6319 7.21736 14 7.21736C14.3682 7.21736 14.6667 7.51584 14.6667 7.88403V8.50441C14.6649 11.7521 12.5271 14.6118 9.41263 15.5326C6.29821 16.4534 2.94906 15.2161 1.18141 12.4916C-0.586246 9.76708 -0.351325 6.20441 1.75878 3.7356C3.86888 1.26678 7.3515 0.479928 10.318 1.80174C10.6544 1.9516 10.8055 2.34571 10.6557 2.68203C10.5058 3.01834 10.1117 3.1695 9.77538 3.01965C7.3482 1.93816 4.49879 2.58195 2.77234 4.60189C1.04589 6.62183 0.853685 9.53674 2.29995 11.7659C3.74621 13.995 6.48642 15.0074 9.03459 14.254C11.5828 13.5006 13.3319 11.1609 13.3334 8.50403ZM5.80478 7.36596L7.33337 8.89455L14.1953 2.03262C14.4557 1.77227 14.8778 1.77227 15.1381 2.03262C15.3985 2.29297 15.3985 2.71508 15.1381 2.97543L7.80478 10.3088C7.54443 10.5691 7.12232 10.5691 6.86197 10.3088L4.86197 8.30877C4.60162 8.04842 4.60162 7.62631 4.86197 7.36596C5.12232 7.10561 5.54443 7.10561 5.80478 7.36596Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIconNotifySuccess);
export default __webpack_public_path__ + "static/media/mainIconNotifySuccess.4ccc89d3cf7f4116729f2ec2d926d441.svg";
export { ForwardRef as ReactComponent };